module.exports = __webpack_public_path__ + "img/volume_off_white_24dp.87da1417.svg";